/* Gogo Language Texts
Table of Contents
01.General
02.User Login, Logout, Register
03.Menu
04.Error Page
*/
import countryList from "./es_country_list";

export default () => {
  return {
    /* 00. Languages */
    en: "Inglés",
    tr: "Turco",
    de: "Alemán",
    /* 01.General */
    countryList,
    "Network Error!": "¡Error de red!",
    "Please check your internet connection": "Por favor, verifica tu conexión a Internet",
    "Please allow notifications": "Por favor, permite las notificaciones",
    Reconnecting: "Reconectando",
    "Retry Now": "Reintentar ahora",
    "You are currently offline": "Estás desconectado",
    "Old Version": "Versión antigua",
    "Your version is old. Please refresh your browser to reload!": "Tu versión está desactualizada. ¡Por favor actualiza tu navegador para recargar!",
    connected_to_the_server: "Conectado al servidor",
    this_user_does_not_have_permission_for_this_hotel: "Este usuario no tiene permiso para este hotel",
    permission_error: "Error de permiso",
    dateOptions: {
      yearFormat: "numérico",
      monthFormat: "largo",
      dayFormat: "2 dígitos",
      locale: "es"
    },
    click_to_load: "Haz clic para cargar más.",
    click_to_load_until: "Mostrando desde la fecha: ",
    click_to_load_number: " Mostrado (",
    seen_all: "Has visto todo.",
    birthdate_format: "DD/MM/AA",
    "form.valid.firstname": "El nombre es obligatorio",
    "form.valid.lastname": "El apellido es obligatorio",
    "form.valid.price": "El precio es obligatorio y debe ser numérico",
    "form.valid.email": "El correo electrónico no es válido",
    "form.valid.mobile": "El número de teléfono no es válido - ej.: +34955xxxxxxx",
    "form.valid.roomnumber": "Número de habitación no válido",
    "form.valid.decimal": "El valor decimal debe ser numérico",
    "link.webeeCode": "Código Webee:",
    "link.copyCode": "Copiar código Webee",
    "link.header": "Generar enlace de pago",
    "link.modalheader": "Enlace",
    "link.copy": "Copiar enlace",
    "link.error": "Ha ocurrido un error, inténtalo de nuevo",
    "createQr.create_link": "QR para descargar con enlace",
    "createQr.create_booking_with_pms": "QR para PMS",
    "createQr.success": "QR creado con éxito",
    "createQr.error": "Ha ocurrido un error, inténtalo de nuevo",
    "link.copied": "Enlace copiado",
    "link.goReport": "Página de informe",
    "report.expired": "Caducado",
    "report.not_expired": "Válido",
    "report.header": "Informe",
    "report.pay": "Pagado",
    "report.no_payments": "No se encontraron pagos",
    "report.not_pay": "No pagado",
    "report.permisson_error_payments": "No tienes permiso para acceder aquí.",
    "forms.firstname": "Nombre",
    "forms.lastname": "Apellido",
    "forms.price": "Precio",
    "forms.email": "Correo electrónico",
    "forms.mobile": "Número de teléfono",
    "forms.phone_number": "+34xxxxxxxxxx",
    "forms.start_date": "Fecha de inicio",
    "forms.end_date": "Fecha de fin",
    "forms.generate": "Generar URL",
    "forms.check_in_check_out": "Check-In / Check-Out:",
    "forms.please_select": "Por favor selecciona",
    "forms.create": "Crear",
    "forms.checkin": "Fecha de entrada",
    "forms.checkout": "Fecha de salida",
    "forms.room_number": "Número de habitación",
    "forms.send_sms": "Enviar SMS",
    "forms.send_email": "Enviar correo electrónico",
    "forms.select_contact": "Puedes seleccionar la información de contacto",
    "forms.select_pms": "Lista de huéspedes",

    /* Alacarte */
    "alacarte.food_undefined": "No hay selección de plato principal disponible para este restaurante.",
    "alacarte.grand_total": "Total General",
    "alacarte.total_order": "Total de pedidos",
    "alacarte.restaurant_name": "Nombre del restaurante",
    "alacarte.request_time": "Hora de la solicitud",
    "alacarte.restaurants_header": "Restaurantes",
    "alacarte.no_restaurants": "No hay restaurantes disponibles",
    "alacarte.mondays": "Lunes",
    "alacarte.tuesdays": "Martes",
    "alacarte.wednesdays": "Miércoles",
    "alacarte.thursdays": "Jueves",
    "alacarte.fridays": "Viernes",
    "alacarte.saturdays": "Sábado",
    "alacarte.sundays": "Domingo",
    "alacarte.quota": "Personas",
    "alacarte.days": "Días",
    "alacarte.success": "Éxito",
    "alacarte.reservation_slot": "Franja de reserva",
    "alacarte.addSlot": "Agregar nuevo",
    "alacarte.removeSlot": "Eliminar",
    "alacarte.stop_res_before_opens_at": "Minutos después de la apertura del restaurante cuando deja de aceptar solicitudes",
    "alacarte.guest_cancel_res_before_open_at": "Minutos antes de la apertura en que los huéspedes pueden cancelar",
    "alacarte.max_guest_count": "Máximo número de invitados para la reserva",
    "alacarte.guest_one_res_each_day": "El invitado puede hacer una reserva por día",
    "alacarte.guest_one_res_per_resturant": "El invitado puede hacer una reserva por restaurante",
    "alacarte.yes": "Sí",
    "alacarte.no": "No",
    "alacarte.alacarte": "A la carta",
    "alacarte.no_config": "Sin selección de días ni preferencias",
    "alacarte.newRequest": "Nueva solicitud",
    "alacarte.available_seats": "Número de personas disponibles",
    "alacarte.info_available_seats": "No hay selección de tiempo",
    "alacarte.main_course": "Plato principal",
    "alacarte.person": "Persona",
    "alacarte.adult": "Adulto",
    "alacarte.adult_count": "Número de adultos",
    "alacarte.child": "Niño",
    "alacarte.room_number": "Número de habitación",
    "alacarte.name": "Nombre y apellido",
    "alacarte.notes": "Notas",
    "alacarte.select_restaurant_and_slot": "Selecciona restaurante y horario",
    "alacarte.people_count": "Número de adultos",
    "alacarte.child_count": "Número de niños",
    "alacarte.create_form": "Crear formulario",
    "alacarte.create_request": "Crear solicitud",
    "alacarte.request_person_info": "Información personal",
    "alacarte.request_no_person_info": "No hay información personal disponible.",
    "alacarte.input_required": "(*) los campos obligatorios deben completarse.",
    "alacarte.print": "Imprimir",
    "alacarte.request_owner_staff": "La solicitud fue creada con StaffApp",
    "alacarte.allday": "Todo el día",
    "alacarte.count": "conteo",
    "alacarte.date": "Fecha",

    /* Fast Checkin */
    "fastCheckin.guests": "Invitados",

    /* 02.User Login, Logout, Register */
    "user.passwordChangeSuccess": "Tu contraseña ha sido cambiada",
    "user.passwordChangeError": "Ha ocurrido un error, inténtalo de nuevo",
    "user.signout": "Cerrar sesión",
    "user.changePassword": "Cambiar contraseña",
    "user.oldPassword": "Contraseña anterior",
    "user.newPassword": "Nueva contraseña",
    "user.confirmationCode": "Código de confirmación",
    "user.cancel": "Cancelar",
    "user.close": "Cerrar",
    "user.resetPassword": "Restablecer contraseña",
    "user.modalChangePassword": "Cambio de contraseña",
    "user.confirmPassword": "Confirmar nueva contraseña",
    "user.login-title": "Inicio de sesión",
    "user.gsmNo": "Número GSM:",
    "user.sendCode": "Enviar código",
    "user.resendCode": "Reenviar código",
    "user.register": "Registrarse",
    "user.forgot-password": "¡Olvidé mi contraseña!",
    "user.email": "Correo electrónico",
    "user.note": "Nota",
    "user.all_number": "Todos los números",
    "user.password": "Contraseña",
    "user.forgot-password-question": "¿Olvidaste tu contraseña?",
    "user.fullname": "Nombre completo",
    "user.login-button": "INICIAR SESIÓN",
    "user.register-button": "REGISTRARSE",
    "user.reset-password-button": "RESTABLECER",
    "user.buy": "COMPRAR",
    "user.username": "Nombre de usuario",
    "user.create": "Crear",
    "user.update": "Actualizar",

    /* 03.Menu */
    "menu.requests": "Solicitudes",
    "menu.bookings": "Confirmación de invitados",
    "menu.fastCheckin": "Check-in sin contacto",
    "menu.logs": "Registro de invitados",
    "menu.lolRequests": "Solicitudes de Land Of Legends",
    "menu.payments": "Pantalla de pago",
    "menu.settings": "Configuraciones",
    "menu.template": "Plantillas",
    "menu.reportProblem": "Informar un problema",
    "menu.problemDescription": "Descripción del problema",
    "menu.chooseTopic": "Por favor, selecciona un tema",
    "menu.descriptionFieldCannotLeftEmpty": "El campo de descripción no puede quedar vacío",
    "menu.problemSubject": "Tema del problema",
    "menu.sendReport": "Enviar informe",
    "menu.sendReportConfirmMessage": "¿Estás seguro de que quieres enviar este informe?",
    "menu.link": "Crear enlace de pago",
    "menu.report": "Informe de pago",
    "menu.app": "Inicio",
    "menu.staff": "Personal",
    "menu.dashboards": "Panel",
    "menu.start": "Inicio",
    "menu.request": "Solicitudes",
    "menu.search": "Buscar",
    "menu.chat": "Chat",
    "menu.blank-page": "Página en blanco",
    "menu.empty_badge": "No hay nuevas notificaciones",
    "menu.alacarte": "Reservas a la carta",
    "menu.restaurant": "Restaurantes",
    "menu.ringTone": "Cambiar tono de notificación",

    /* 04.Pages */
    "pages.error-title": "Ooops... ¡parece que ocurrió un error!",
    "pages.error-code": "Código de error",
    "pages.go-back-home": "VOLVER AL INICIO",
    "pages.display-options": "Ver opciones",
    "pages.orderby": "Ordenar por : ",

    /* 05.Request */
    "request.payable": "Solicitud pagadera",
    "request.payable_status": "Estado del pago",
    "request.payable_total_amount": "Monto total",
    "request.payable_currency": "Moneda",
    "request.payable_payment": "Pago",
    "request.no_payable_details": "No hay detalles disponibles todavía",

    "request.payable_status_paid": "Pagado",
    "request.payable_status_canceled": "Cancelado",
    "request.payable_status_awaiting_payment": "Pago pendiente",

    "request.order_number": "Lugar de la solicitud",
    "request.add-new": "CREAR SOLICITUD",
    "request.add-new-title": "Crear nueva solicitud",
    "request.title": "Título",
    "request.comment": "Comentario",
    "request.due": "Para cuándo",
    "request.detail": "Detalle",
    "request.category": "Tipo de servicio",
    "request.label": "Etiqueta",
    "request.cancel": "Cancelar",
    "request.error": "Por favor selecciona al menos un tipo de servicio",
    "request.submit": "Enviar",
    "request.request_details": "Detalles de la solicitud",
    "request.display-options": "Ver opciones",
    "request.orderby": "Ordenar por : ",
    "request.all-tasks": "Todas",
    "request.pending-tasks": "Pendientes",
    "request.open-tasks": "Abiertas",
    "request.completed-tasks": "Resueltas",
    "request.categories": "Tipos de servicio",
    "request.clear": "Limpiar",
    "request.room": "Habitación",
    "request.collapse_all": "Contraer todo",
    "request.expand_all": "Expandir todo",
    "request.no_booking_info": "No hay información de reserva",
    "request.chat_say_something": "Enviar mensaje al huésped...",
    "request.message_title": "Mensajes",
    "request.back_button": "Atrás",
    "request.clear_filters": "Limpiar filtros",
    "request.status_open": "Abierto",
    "request.status_pending": "Pendiente",
    "request.status_closed": "Resuelto",
    "request.status_canceled": "Cancelado",
    "request.last_update": "Última actualización: ",
    "request.created_at": "Creado: ",
    "request.due_date": "Fecha de vencimiento: ",
    "request.message_view_translation": "Ver traducción",
    "request.message_show_original": "Ver original",
    "request.message_translation_detect": "DETECTADO",
    "request.message_translation": "TRADUCIDO",
    "request.Creation Date": "Fecha de creación",
    "request.Last Update": "Última actualización",
    "request.Due Date": "Fecha de vencimiento",
    "request.Guest Name": "Nombre del huésped",
    "request.Service Name": "Nombre del servicio",
    "request.Status": "Estado",
    "request.Label": "Etiqueta",
    "request.details": "Detalles",
    "request.status": "Estado",
    "request.list_status_canceled": "Cancelado",
    "request.empty_message_box": "El buzón de mensajes está vacío",
    "request.message_send_button": "Enviar",
    "request.upload": "Subir",
    "request.empty_request_list": "No hay solicitudes",
    "request.wrong_request_page": "No se encontró dicha solicitud",
    "request.awaiting_approval_status_message": "Debes actualizar el estado de la reserva del huésped antes de realizar cualquier acción.",
    "request.pageUp": "Arriba",
    "request.create_qr": "Crear QR",
    "request.create_qr_pms": "WeBee PASS",
    "request.modalCreateQR": "WeBee PASS",
    "request.survey_score": "Puntuación de la encuesta",

    /* 06.Booking */
    "booking.guest_information_form": "Formulario de información del huésped",
    "booking.signature": "Firma",
    "booking.date": "Fecha",
    "booking.full_name": "Nombre / Apellido",
    "booking.has_traveled": "He viajado en los últimos 14 días.",
    "booking.billing_address": "Dirección de facturación",
    "booking.passport_front": "Parte delantera del pasaporte",
    "booking.passport_back": "Parte trasera del pasaporte",
    "booking.address": "Dirección",
    "booking.city": "Ciudad",
    "booking.country": "País",
    "booking.town_of_registry": "Municipio de registro",
    "booking.city_of_registry": "Ciudad de registro",
    "booking.serial_number": "Número de serie",
    "booking.document_type": "Tipo de documento",
    "booking.date_of_issue": "Fecha de emisión",
    "booking.date_of_expire": "Fecha de caducidad",
    "booking.birth_place": "Lugar de nacimiento",
    "booking.mother_name": "Nombre de la madre",
    "booking.father_name": "Nombre del padre",
    "booking.room_assignment": "Asignación de habitación",
    "booking.OK": "OK",
    "booking.car_plate": "Placa del coche",
    "booking.dietary_requirements": "Requisitos alimentarios (si los hay)",
    "booking.postal_code": "Código postal",
    "booking.arrival_flight": "Vuelo de llegada",
    "booking.departure_flight": "Vuelo de salida",
    "booking.visa_type": "Tipo de visa",
    "booking.visa_expiry_date": "Fecha de caducidad de la visa",
    "booking.reservation_channel": "Canal de reserva",
    "booking.time_of_arrival_at_hotel": "Hora de llegada al hotel",
    "booking.all-reservations": "Todas",
    "booking.add-new": "NUEVA SOLICITUD",
    "booking.firstname-label": "Nombre",
    "booking.lastname-label": "Apellido",
    "booking.internal-notes-label": "Notas internas",
    "booking.phone-label": "Teléfono",
    "booking.firstname-placeholder": "Nombre",
    "booking.lastname-placeholder": "Apellido",
    "booking.internal-notes-placeholder": "Notas internas",
    "booking.phone-placeholder": "Número de teléfono",
    "booking.add-new-modal-title": "Crear nueva reserva",
    "booking.label": "Etiqueta",
    "booking.status": "Estado",
    "booking.submit": "Enviar",
    "booking.cancel": "Cancelar",
    "booking.display-options": "Ver opciones",
    "booking.room": "Habitación",
    "booking.empty_booking_list": "No hay reservas",
    "booking.empty_request_list": "No hay reservas",
    "booking.booking_summary": "Resumen de la reserva",
    "booking.checkin": "Llegada",
    "booking.checkout": "Salida",
    "booking.orderby": "Ordenar por : ",
    "booking.status_hotel_guest": "Huésped del hotel",
    "booking.status_future_guest": "Futuro huésped",
    "booking.status_awaiting_approval": "Esperando aprobación",
    "booking.status_invalid_booking": "Reserva inválida",
    "booking.status_checked_out": "Huésped anterior",
    "booking.hescode": "Código HES",
    "booking.TM6Form_number": "Número de formulario TM6",
    "bookingDetails.back_button": "Atrás",
    "bookingDetails.checkin": "Check-in",
    "bookingDetails.checkout": "Check-out",
    "bookingDetails.hotel_guest": "Huésped del hotel",
    "bookingDetails.future_guest": "Futuro huésped",
    "bookingDetails.awaiting_approval": "Esperando aprobación",
    "bookingDetails.invalid_booking": "Reserva inválida",
    "bookingDetails.checked_out": "Huésped anterior",
    "bookingDetails.room": "Habitación",
    "bookingDetails.tp_id": "ID de origen de PMS (ID de origen)",
    "bookingDetails.room_info": "sin información de habitación",
    "bookingDetails.last_update": "Última actualización: ",
    "bookingDetails.created_at": "Creado el: ",
    "bookingDetails.reservation_number": "Número de reserva",
    "bookingDetails.national_identification_number": "Número de identificación nacional",
    "bookingDetails.passport_number": "Número de pasaporte",
    "bookingDetails.birth_date": "Fecha de nacimiento",
    "bookingDetails.checkin_checkout": "Check-in / Check-out",
    "bookingDetails.checkin_checkout_time": "Hora de check-in / Hora de check-out",
    "bookingDetails.keyless_active_switch": "Activo",
    "bookingDetails.keyless_invoke": "Limpiar tarjeta",
    "bookingDetails.gender": "Género",
    "bookingDetails.genderFemale": "Femenino",
    "bookingDetails.genderMale": "Masculino",
    "bookingDetails.nationality": "Nacionalidad",
    "booking.wrong_booking_page": "No se encontró dicha reserva",
    "bookingDetails.check_with_pms": "Controlar el número de habitación con PMS",
    "bookingDetails.check_with_pms_button": "Control de PMS",
    "booking.loyalty_program": "Programa de lealtad",
    "bookingDetails.Loyalty_and_preferences": "Programa de lealtad y preferencias del huésped",
    "bookingDetails.loyalty_point": "Punto de lealtad",
    "bookingDetails.guest_preferences": "Preferencias del huésped",

    // 07 Guest Logs
    "logs.add-new-title": "Crear nuevo registro de huésped",
    "logs.entered-date": "Fecha de registro",
    "logs.time-in": "Hora de check-in",
    "logs.time-out": "Hora de check-out",
    "logs.notes": "Notas",
    "logs.newLog": "Nuevo registro",

    // 08 Easee
    "menu.easee": "EaSee",
    "menu.webeeadmin": "Admin Webee",

    // 09 Template Message
    "template.newTemplate": "Nueva plantilla",
    "template.language": "Idioma",
    "template.title": "Título",
    "template.text": "Texto",
    "template.choose": "Selecciona tu mensaje de plantilla",
    "template.chooseLang": "Selecciona un idioma",
    "template.add": "Agregar nueva plantilla",
    "template.edit": "Editar plantilla",
    "template.save": "Guardar",
    "template.cancel": "Cancelar",
    "template.noTemplate": "No se encontró ninguna plantilla, por favor agrega una nueva",
    "template.delete": "¿Estás seguro de que deseas eliminar esta plantilla?",
    "template.delete-title": "Eliminar plantilla",
    "template.delete-button": "Eliminar",

    // 10 Ringtone
    "ringTone.sound": "Sonido",
    "ringTone.playChoose": "Reproducir / Seleccionar",

    // 11 Announcement
    "announcement.popupSubject": "¡Nueva función: la forma fácil de informar problemas!",
    "announcement.popupBody": "Si tienes algún problema o sugerencia con StaffApp, puedes informar fácilmente a nuestro equipo de soporte a través de la pestaña 'Informar problema' en la configuración."
  };
};
